import { getNativeAppPlatform } from './nativeApp'

// Opens "Continue with Google / X". The Android app keeps script navigations
// inside its WebView, where the phone's Google account isn't available and
// Google refuses embedded sign-in. It hands window.open to the system browser,
// so there the app asks the API for the provider address and opens that.
export const openOAuthProvider = async (startUrl: string): Promise<void> => {
    if (getNativeAppPlatform() === 'android') {
        try {
            const response = await fetch(startUrl, { headers: { Accept: 'application/json' } })
            const data = response.ok ? await response.json() : null
            if (typeof data?.url === 'string' && window.open(data.url, '_blank')) return
        } catch (_error) {
            // Fall back to signing in inside the WebView.
        }
    }

    window.location.assign(startUrl)
}
